// extracted by css-extract-rspack-plugin
export default {"triggerButton":"AyJHI","chevronIcon":"KEf4W","triggerButtonLabel":"jUEuR","chevronDown":"AtfP5","selectListItem":"qm3Z3","moreButton":"ILigB"};